// Jump from one project or person to another without going back to the list (PRD rev. 1.6). Type to
// filter; picking one navigates. The editor's unsaved-changes guard still asks before leaving.

import { useState } from "react";
import { Combobox, Option, OptionGroup } from "@fluentui/react-components";

export interface SwitchItem {
  id: string;
  text: string;
  group: string;
}

const SHOWN = 60;

export function Switcher({ label, items, current, onPick }: { label: string; items: SwitchItem[]; current: string; onPick: (id: string) => void }) {
  const [query, setQuery] = useState("");
  const q = query.trim().toLowerCase();
  const matches = items.filter((i) => i.id !== current && (!q || i.text.toLowerCase().includes(q)));
  const shown = matches.slice(0, SHOWN);
  const groups = [...new Set(shown.map((i) => i.group))];
  return (
    <Combobox
      className="switcher"
      size="small"
      aria-label={label}
      placeholder={label}
      value={query}
      selectedOptions={[]}
      onChange={(e) => setQuery(e.target.value)}
      onOptionSelect={(_, d) => {
        if (!d.optionValue) return;
        setQuery("");
        onPick(d.optionValue);
      }}
    >
      {shown.length === 0 ? (
        <Option disabled text="No match">
          No match
        </Option>
      ) : (
        groups.map((g) => (
          <OptionGroup key={g} label={g}>
            {shown
              .filter((i) => i.group === g)
              .map((i) => (
                <Option key={i.id} value={i.id} text={i.text}>
                  {i.text}
                </Option>
              ))}
          </OptionGroup>
        ))
      )}
      {matches.length > SHOWN && (
        <Option disabled text="More">
          {`${matches.length - SHOWN} more: keep typing to narrow the list`}
        </Option>
      )}
    </Combobox>
  );
}
